/*
  This file is for matching our version of fieldIds to the servers version of fieldIds.
  For simplicity, it's best to try and match the import order of each field to the
  import order of each form section's file.
*/
import { impactedLocation } from 'AppSrc/core/components/forms/form-types/create-crq/relationships/relationships-modal/impacted-location';
/* section-one.jsx */
import { CHANGE_TYPE } from 'AppSrc/core/components/forms/form-types/create-crq/section-one/section-one';
// import { selectNetworkParams } from 'AppSrc/core/components/forms/form-types/create-crq/section-one/select-network-params';
import {
  selectNetworkParamsId,
} from 'AppSrc/core/components/forms/form-types/create-crq/section-one/section-one-constants';
/* section-two.jsx */
import { CHANGE_QUESTIONS } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/section-two';
import { whyShouldThisChangeBeExpedited } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/why-should-this-change-be-expedited';
/*
  <Fields that are not submitted, they instead become a WII>
*/
import { businessJustificationA } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/business-justification-a';
import { businessJustificationB } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/business-justification-b';
import { businessJustificationC } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/business-justification-c';
/*
  </ Fields that are not submitted, they instead become a WII>
*/
import { impact } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/impact';
import { firstSiteImplementationParams } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/first-site-implementation-params';
import { firstSiteImplementationBParams } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/first-site-implementation-b-params';
import { testingStatus } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/testing-status';
import { acceptanceSignOff } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/acceptance-sign-off';
import { isRegressionPossible } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/is-regression-possible';
import { regressionPlanTested } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/regression-plan-tested';
import { changeScopeTechnology } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/change-scope-technology';
import { changeScopeDomain } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/change-scope-domain';
import { cisAffectedResilient } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/cis-affected-resilient';
import { serviceOutageRequired } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/service-outage-required';
import { serviceOutageRequiredForRegressionActivity } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/service-outage-required-for-regression-activity';
import { serviceOutageDuration } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/service-outage-duration';
import { failureBeBusinessCritical } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/failure-be-business-critical';
import { completeBackoutEasilyAchievable } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/complete-backout-easily-achievable';
import { whatTestingHasBeenCarriedOut } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/what-testing-has-been-carried-out';
import { newVersionsOfSoftware } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/new-versions-of-software';
import { newProductTechnology } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/new-product-technology';
import { vendorSupportForChange } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/vendor-support-for-change';
import { changeMultiSiteMultiCustomerAffecting } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/change-multi-site-multi-customer-affecting';
import { implementersImplementedThisChangeBefore } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/implementers-implemented-this-change-before';
import { backoutAndTestCompleted } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/backout-and-test-completed';
import { customerImpacting } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/customer-impacting';
import { affectsInventoryCmdbOss } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/affects-inventory-cmdb-oss';
import { provideRequiredLeadTime } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/provide-required-lead-time';
import { requiresPreChangeLabTestingResults } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/requires-pre-change-lab-testing-results';
import {
  selectChangeSlaId,
  requiresNetworkItSecurityApprovalId,
  whyNoNetworkItSecurityApprovalId,
  customerImpactingId,
} from 'AppSrc//core/components/forms/form-types/create-crq/section-two/section-two-constants';
/* section-three.jsx */
import { START_AND_END_DATE } from 'AppSrc/core/components/forms/form-types/create-crq/section-three/section-three';
import { scheduledStartDate } from 'AppSrc/core/components/forms/form-types/create-crq/section-three/scheduled-start-date';
import { scheduledEndDate } from 'AppSrc/core/components/forms/form-types/create-crq/section-three/scheduled-end-date';
import { owStartDate } from 'AppSrc/core/components/forms/form-types/create-crq/section-three/ow-start-date';
import { owEndDate } from 'AppSrc/core/components/forms/form-types/create-crq/section-three/ow-end-date';
/* section-four.jsx */
import { CHANGE_DETAILS } from 'AppSrc/core/components/forms/form-types/create-crq/section-four/section-four';
import { whichServiceNeedsToChange } from 'AppSrc/core/components/forms/form-types/create-crq/section-four/which-service-needs-to-change';
import { summaryOfChange } from 'AppSrc/core/components/forms/form-types/create-crq/section-four/summary-of-change';
import { changeDetailsNotes } from 'AppSrc/core/components/forms/form-types/create-crq/section-four/change-details-notes';
import { customerImpactStatement } from 'AppSrc/core/components/forms/form-types/create-crq/section-four/customer-impact-statement';
import { productCategorisationOne } from 'AppSrc/core/components/forms/form-types/create-crq/section-four/product-categorisation-one';
import { productCategorisationTwo } from 'AppSrc/core/components/forms/form-types/create-crq/section-four/product-categorisation-two';
import { productCategorisationThree } from 'AppSrc/core/components/forms/form-types/create-crq/section-four/product-categorisation-three';
import { operationalCategorisationOne } from 'AppSrc/core/components/forms/form-types/create-crq/section-four/operational-categorisation-one';
import { operationalCategorisationTwo } from 'AppSrc/core/components/forms/form-types/create-crq/section-four/operational-categorisation-two';
import { operationalCategorisationThree } from 'AppSrc/core/components/forms/form-types/create-crq/section-four/operational-categorisation-three';
import { tmbs } from 'AppSrc/core/components/forms/form-types/create-crq/section-four/tmbs';
import { babt } from 'AppSrc/core/components/forms/form-types/create-crq/section-four/babt';
import { iarNumber } from 'AppSrc/core/components/forms/form-types/create-crq/section-four/iar-number';
import { mvno } from 'AppSrc/core/components/forms/form-types/create-crq/section-four/mvno';
import { commQuestion } from 'AppSrc/core/components/forms/form-types/create-crq/section-four/comms-question';
import { assignSponsor } from 'AppSrc/core/components/forms/form-types/create-crq/section-four/assign-sponsor';
import { company } from 'AppSrc/core/components/forms/form-types/create-crq/section-four/company';
import { region } from 'AppSrc/core/components/forms/form-types/create-crq/section-four/region';
import { siteGroup } from 'AppSrc/core/components/forms/form-types/create-crq/section-four/site-group';
import { site } from 'AppSrc/core/components/forms/form-types/create-crq/section-four/site';
import { productName } from 'AppSrc/core/components/forms/form-types/create-crq/section-four/product-name';
import { productModel } from 'AppSrc/core/components/forms/form-types/create-crq/section-four/product-model';
import { manufacturer } from 'AppSrc/core/components/forms/form-types/create-crq/section-four/manufacturer';
import {
  CHANGE_REASON,
} from 'AppSrc//core/components/forms/form-types/create-crq/section-four/section-four-constants';
/* stuff for WII... basically section-five.jsx */
import {
  SUMMARY,
  WORK_INFORMATION_TYPE,
} from 'AppSrc/core/components/forms/form-types/create-crq/section-five/work-information-items/work-information-item-constants';
/* references-section.jsx */
import {
  REFERENCES_SECTION,
  APPROVERS_SECTION,
  COMPLETION_REVIEW,
  RELATIONSHIPS,
} from 'AppSrc/core/components/forms/form-types/create-crq/form-definition/section-constants';
import { pou } from 'AppSrc/core/components/forms/form-types/create-crq/references-section/pou';
import { project } from 'AppSrc/core/components/forms/form-types/create-crq/references-section/project';
import { customer } from 'AppSrc/core/components/forms/form-types/create-crq/references-section/customer';
import { incident } from 'AppSrc/core/components/forms/form-types/create-crq/references-section/incident';
import { criticalCustomerList } from 'AppSrc/core/components/forms/form-types/create-crq/references-section/critical-customer-list';
/* approvers-section.jsx */
import { approverGroupNames } from 'AppSrc/core/components/forms/form-types/create-crq/approvers-section/approver-group-names';
/* completion review section */
import { changeFollowImplementationPlan } from 'AppSrc/core/components/forms/form-types/completion-review/section-one/change-follow-implementation-plan';
import { deliverExpectedResults } from 'AppSrc/core/components/forms/form-types/completion-review/section-one/deliver-expected-results';
import { changeCauseIncident } from 'AppSrc/core/components/forms/form-types/completion-review/section-one/change-cause-incident';
import { completedWithinChangeWindowWithoutAdditionalImpacts } from 'AppSrc/core/components/forms/form-types/completion-review/section-one/completed-within-change-window-without-additional-impacts';
import { changeRequestRegressed } from 'AppSrc/core/components/forms/form-types/completion-review/section-one/change-request-regressed';
import { hasItBeenUpdated } from 'AppSrc/core/components/forms/form-types/completion-review/section-one/has-it-been-updated';
import { actualStartDate } from 'AppSrc/core/components/forms/form-types/completion-review/section-two/actual-start-date';
import { actualEndDate } from 'AppSrc/core/components/forms/form-types/completion-review/section-two/actual-end-date';
import { postChangeCommsSelector } from 'AppSrc/core/components/forms/form-types/completion-review/section-three/post-change-comms-selector';
import { causedChangeFail } from 'AppSrc/core/components/forms/form-types/completion-review/section-failure/caused-change-fail';
import { impactedControl } from 'AppSrc/core/components/forms/form-types/completion-review/section-failure/impacted_control';
import { impactServicesCustomers } from 'AppSrc/core/components/forms/form-types/completion-review/section-failure/impact_services_customers';
import { provideDetailsOfRegression } from 'AppSrc/core/components/forms/form-types/completion-review/section-one/provide-details-of-regression';
import { enterIncidentReference } from 'AppSrc/core/components/forms/form-types/completion-review/section-one/enter-incident-reference';
import { correctiveActionOwnerName } from 'AppSrc/core/components/forms/form-types/completion-review/section-failure/corrective_action_owner_name';
import { correctiveActionOwnerEmail } from 'AppSrc/core/components/forms/form-types/completion-review/section-failure/corrective_action_owner_email';
import { correctiveActionOwnerMobileNumber } from 'AppSrc/core/components/forms/form-types/completion-review/section-failure/corrective_action_owner_mobile_number';
import { correctiveActionCompletion } from 'AppSrc/core/components/forms/form-types/completion-review/section-failure/corrective_action_completion';
import { expectedCompletionDate } from 'AppSrc/core/components/forms/form-types/completion-review/section-failure/expected_completion_date';
import { measuresNeeded } from 'AppSrc/core/components/forms/form-types/completion-review/section-failure/measures_needed';
import { changeCoordinatorName } from '../../completion-review/section-failure/change-coordinator-name';
import { changeCoordinatorEmail } from '../../completion-review/section-failure/change-coordinator-email';
import { changeCoordinatorMobileNumber } from '../../completion-review/section-failure/change-coordinator-mobile-number';
import { changeImplementerEngineerName } from '../../completion-review/section-failure/change-implementation-engineer-name';
import { changeImplementerEngineerEmail } from '../../completion-review/section-failure/change-implementation-engineer-email';
import { changeImplementerEngineerMobileNumber } from '../../completion-review/section-failure/change-implementation-engineer-mobile';
import { causedServiceOutage } from '../../completion-review/section-failure/caused-service-outage';
import { durationOfOutage } from '../../completion-review/section-failure/duration-of-outage';
import { reasonForFailure } from '../../completion-review/section-failure/reason-for-failure';
import { associatedIncidentReference } from '../../completion-review/section-failure/associated-incident-reference';
import { changeImpactTechnologyRecoverPlan } from '../section-two/change-impact-technology-recovery-plans';
import { whyNoChangeInTechnologyRecoveryPlans } from '../section-two/why-no-change-in-technology-recovery-plans';
import { oloRequiredInternationalServices } from '../section-one/olo-req-international-ser';
import { whatWasAffected } from '../../completion-review/section-failure/what-was-affected';
import { rootcauseReasonone } from '../../completion-review/section-failure/rootcause-reason-one';
import { rootcauseReasontwo } from '../../completion-review/section-failure/rootcause-reason-two';
import { rootcauseReasonthree } from '../../completion-review/section-failure/rootcause-reason-three';
import { changeImpactTechnologyRecoverPlanFixed } from '../section-two/change-impact-technology-recovery-plans-fixed';
import { whyNoChangeInTechnologyRecoveryPlansFixed } from '../section-two/why-no-change-in-technology-recovery-plans-fixed';


// array of sections and fields that map fieldIds to parameters

const sectionParameterFieldMap = [
  {
    sectionId: CHANGE_TYPE,
    fields: [
      { param: 'network', field: selectNetworkParamsId },
      { param: 'timing', field: selectChangeSlaId },
      { param: 'olo_req_international_services', field: oloRequiredInternationalServices.id },
    ],
  },
  {
    sectionId: CHANGE_QUESTIONS,
    fields: [
      { param: 'timing', field: selectChangeSlaId },
      { param: 'timing_reason', field: whyShouldThisChangeBeExpedited.id },
      { param: 'first_site_implementation', field: firstSiteImplementationParams.id },
      // Question is "Did the change fail on the first implementation?", but the server key is 'last-implementation-failed'
      { param: 'last_implementation_failed', field: firstSiteImplementationBParams.id },
      { param: 'testing_status', field: testingStatus.id },
      { param: 'has_acceptance', field: acceptanceSignOff.id },
      { param: 'regression_possible', field: isRegressionPossible.id },
      { param: 'regression_tested', field: regressionPlanTested.id },
      { param: 'change_scope_tech', field: changeScopeTechnology.id },
      { param: 'change_scope_domain', field: changeScopeDomain.id },
      { param: 'affected_cis_resilient', field: cisAffectedResilient.id },
      { param: 'technology_plan_required', field: changeImpactTechnologyRecoverPlan.id },
      { param: 'technology_plan_exclusion', field: whyNoChangeInTechnologyRecoveryPlans.id },
      { param: 'technology_plan_required_fixed', field: changeImpactTechnologyRecoverPlanFixed.id },
      { param: 'technology_plan_exclusion_fixed', field: whyNoChangeInTechnologyRecoveryPlansFixed.id },
      { param: 'service_outage_required', field: serviceOutageRequired.id },
      { param: 'service_outage_required_regression', field: serviceOutageRequiredForRegressionActivity.id },
      { param: 'service_outage_duration', field: serviceOutageDuration.id },
      { param: 'impact', field: impact.id },
      { param: 'failed_implementation_critical', field: failureBeBusinessCritical.id },
      { param: 'backout_achievable', field: completeBackoutEasilyAchievable.id },
      { param: 'testing', field: whatTestingHasBeenCarriedOut.id },
      { param: 'software_status', field: newVersionsOfSoftware.id },
      { param: 'technology_status', field: newProductTechnology.id },
      { param: 'vendor_support', field: vendorSupportForChange.id },
      { param: 'multi_site_affecting', field: changeMultiSiteMultiCustomerAffecting.id },
      { param: 'implementer_experience', field: implementersImplementedThisChangeBefore.id },
      { param: 'prep_plans_completed', field: backoutAndTestCompleted.id },
      { param: 'customer_impact', field: customerImpacting.id },
      // The question is: Does this change data in the CMDB or inventory systems?
      { param: 'data_impact', field: affectsInventoryCmdbOss.id },
      { param: 'lead_time_provided', field: provideRequiredLeadTime.id },
      { param: 'lab_evidence_required', field: requiresPreChangeLabTestingResults.id },
      { param: 'it_approval_required', field: requiresNetworkItSecurityApprovalId },
      { param: 'it_approval_exclusion', field: whyNoNetworkItSecurityApprovalId },
      { param: 'customer_impact', field: customerImpactingId },
    ],
  },
  {
    sectionId: START_AND_END_DATE,
    fields: [
      { param: 'scheduled_start_date', field: scheduledStartDate.id },
      { param: 'scheduled_end_date', field: scheduledEndDate.id },
      { param: 'outage_start_date', field: owStartDate.id },
      { param: 'outage_end_date', field: owEndDate.id },
    ],
  },
  {
    sectionId: CHANGE_DETAILS,
    fields: [
      { param: 'service', field: whichServiceNeedsToChange.id },
      { param: 'summary', field: summaryOfChange.id },
      { param: 'notes', field: changeDetailsNotes.id },
      { param: 'customer_impact_statement', field: customerImpactStatement.id },
      { param: 'change_reason', field: CHANGE_REASON },
      { param: 'product_cat_1', field: productCategorisationOne.id },
      { param: 'product_cat_2', field: productCategorisationTwo.id },
      { param: 'product_cat_3', field: productCategorisationThree.id },
      { param: 'op_cat_1', field: operationalCategorisationOne.id },
      { param: 'op_cat_2', field: operationalCategorisationTwo.id },
      { param: 'op_cat_3', field: operationalCategorisationThree.id },
      { param: 'tmbs', field: tmbs.id },
      { param: 'babt_notify', field: babt.id },
      { param: 'iar_number', field: iarNumber.id },
      { param: 'mvno', field: mvno.id },
      { param: 'comms_required', field: commQuestion.id },
      { param: 'company', field: company.id },
      { param: 'region', field: region.id },
      { param: 'site_group', field: siteGroup.id },
      { param: 'site', field: site.id },
      { param: 'product_name', field: productName.id },
      { param: 'product_model', field: productModel.id },
      { param: 'manufacturer', field: manufacturer.id },
    ],
  },
  {
    sectionId: REFERENCES_SECTION,
    fields: [
      { param: 'pou', field: pou.id },
      { param: 'rel_project_id', field: project.id },
      { param: 'customer', field: customer.id },
      { param: 'rel_incident_id', field: incident.id },
      { param: 'critical_customers', field: criticalCustomerList.id, asArray: true },
    ],
  },
  {
    sectionId: COMPLETION_REVIEW,
    fields: [
      { param: 'follow_approved_plan', field: changeFollowImplementationPlan.id },
      { param: 'deliver_expected_benefits', field: deliverExpectedResults.id },
      { param: 'cause_an_incident', field: changeCauseIncident.id },
      { param: 'complete_within_approved_window', field: completedWithinChangeWindowWithoutAdditionalImpacts.id },
      { param: 'change_regressed', field: changeRequestRegressed.id },
      { param: 'impacted_inventory_updated', field: hasItBeenUpdated.id },
      { param: 'actual_start_date', field: actualStartDate.id },
      { param: 'actual_end_date', field: actualEndDate.id },
      { param: 'status_reason', field: postChangeCommsSelector.id },
      { param: 'change_coordinator_name', field: changeCoordinatorName.id },
      { param: 'change_coordinator_email', field: changeCoordinatorEmail.id },
      { param: 'change_coordinator_mobile_number', field: changeCoordinatorMobileNumber.id },
      { param: 'change_implementer_engineer_name', field: changeImplementerEngineerName.id },
      { param: 'change_implementer_engineer_email', field: changeImplementerEngineerEmail.id },
      { param: 'change_implementer_engineer_mobile_number', field: changeImplementerEngineerMobileNumber.id },
      { param: 'cause_service_outage', field: causedServiceOutage.id },
      { param: 'duration_of_outage', field: durationOfOutage.id },
      { param: 'reason_for_failure', field: reasonForFailure.id },
      { param: 'associated_incident_ref', field: associatedIncidentReference.id },
      { param: 'service_affected', field: whatWasAffected.id },
      { param: 'root_cause_reason1', field: rootcauseReasonone.id },
      { param: 'root_cause_reason2', field: rootcauseReasontwo.id },
      { param: 'root_cause_reason3', field: rootcauseReasonthree.id },
      { param: 'measures_needed', field: measuresNeeded.id },
      { param: 'corrective_action_owner_name', field: correctiveActionOwnerName.id },
      { param: 'corrective_action_owner_email', field: correctiveActionOwnerEmail.id },
      { param: 'corrective_action_owner_mobile_number', field: correctiveActionOwnerMobileNumber.id },
      { param: 'corrective_action_completion', field: correctiveActionCompletion.id },
      { param: 'corrective_action_completion_date', field: expectedCompletionDate.id },
      { param: 'failure_review_q1', field: causedChangeFail.id },
      { param: 'failure_review_q3', field: impactedControl.id },
      { param: 'failure_review_q2', field: impactServicesCustomers.id },
      { param: 'failure_regression_details', field: provideDetailsOfRegression.id },
      { param: 'failure_incident_reference', field: enterIncidentReference.id },
    ],
  },
  {
    sectionId: RELATIONSHIPS,
    fields: [
      { param: 'impacted_location', field: impactedLocation.id },
    ],
  },
  {
    sectionId: APPROVERS_SECTION,
    fields: [
    ],
  },
];

const OloParameters = [
  'outage-start-date',
  'outage-end-date',
  'failed_implementation_critical',
  'backout_achievable',
  'testing',
  'software_status',
  'technology_status',
  'vendor_support',
  'multi_site_affecting',
  'implementer_experience',
  'prep_plans_completed',
  'customer_impact',
  'data_impact',
  'lead_time_provided',
  'lab_evidence_required',
  'it_approval_required',
  'it_approval_exclusion',
  'company',
  'summary-of-change',
  'change-details-notes',
  'change_reason',
  'prod-cat-one',
  'prod-cat-two',
  'prod-cat-three',
  'product_name',
  'product_model',
  'manufacturer',
  'op-cat-one',
  'op-cat-two',
  'op-cat-three',
  'project',
  'customer',
  'incident',
  'critical_customer_list',
];
const nonServerSectionParameterFieldMap = [
  {
    sectionId: CHANGE_QUESTIONS,
    fields: [
      { param: businessJustificationA.id, field: businessJustificationA.id },
      { param: businessJustificationB.id, field: businessJustificationB.id },
      { param: businessJustificationC.id, field: businessJustificationC.id },
    ],
  },
  {
    sectionId: CHANGE_DETAILS,
    fields: [
      { param: 'sponsor', field: assignSponsor.id },
    ],
  },
  {
    sectionId: APPROVERS_SECTION,
    fields: [
      { param: 'approvers', field: approverGroupNames.id },
    ],
  },
];



const createFullSectionParameterFieldMap = () => {
  const fullSectionParameterFieldMap = sectionParameterFieldMap.map((section) => {
    const nonServerSection = nonServerSectionParameterFieldMap.find((foundSection) => section.sectionId === foundSection.sectionId);
    if (nonServerSection) {
      const enrichedSection = {
        ...section,
        fields: [
          ...section.fields,
          ...nonServerSection.fields,
        ],
      };
      return enrichedSection;
    }
    return section;
  });
  return fullSectionParameterFieldMap;
};



// same as sectionParameterFieldMap but contains values not submitted to server
const fullSectionParameterFieldMap = createFullSectionParameterFieldMap();


const workInfoItemParameterMap = [
  { param: 'info_type', field: WORK_INFORMATION_TYPE },
  { param: 'summary', field: SUMMARY },
];

export {
  sectionParameterFieldMap,
  fullSectionParameterFieldMap,
  workInfoItemParameterMap,
  OloParameters,
};
